/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createLoadChainage } from '../fn/load-chainage-controller/create-load-chainage';
import { CreateLoadChainage$Params } from '../fn/load-chainage-controller/create-load-chainage';
import { deleteLoadChainage } from '../fn/load-chainage-controller/delete-load-chainage';
import { DeleteLoadChainage$Params } from '../fn/load-chainage-controller/delete-load-chainage';
import { getLoadChainage } from '../fn/load-chainage-controller/get-load-chainage';
import { GetLoadChainage$Params } from '../fn/load-chainage-controller/get-load-chainage';
import { getLoadChainages } from '../fn/load-chainage-controller/get-load-chainages';
import { GetLoadChainages$Params } from '../fn/load-chainage-controller/get-load-chainages';
import { getLoadChainagesFiltered } from '../fn/load-chainage-controller/get-load-chainages-filtered';
import { GetLoadChainagesFiltered$Params } from '../fn/load-chainage-controller/get-load-chainages-filtered';
import { LoadChainageDto } from '../models/load-chainage-dto';
import { PageLoadChainageDto } from '../models/page-load-chainage-dto';
import { updateLoadChainage } from '../fn/load-chainage-controller/update-load-chainage';
import { UpdateLoadChainage$Params } from '../fn/load-chainage-controller/update-load-chainage';

@Injectable({ providedIn: 'root' })
export class LoadChainageControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLoadChainage()` */
  static readonly GetLoadChainagePath = '/v1/loadchainages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoadChainage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoadChainage$Response(params: GetLoadChainage$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadChainageDto>> {
    return getLoadChainage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoadChainage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoadChainage(params: GetLoadChainage$Params, context?: HttpContext): Observable<LoadChainageDto> {
    return this.getLoadChainage$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoadChainageDto>): LoadChainageDto => r.body)
    );
  }

  /** Path part for operation `updateLoadChainage()` */
  static readonly UpdateLoadChainagePath = '/v1/loadchainages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLoadChainage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoadChainage$Response(params: UpdateLoadChainage$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadChainageDto>> {
    return updateLoadChainage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLoadChainage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoadChainage(params: UpdateLoadChainage$Params, context?: HttpContext): Observable<LoadChainageDto> {
    return this.updateLoadChainage$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoadChainageDto>): LoadChainageDto => r.body)
    );
  }

  /** Path part for operation `deleteLoadChainage()` */
  static readonly DeleteLoadChainagePath = '/v1/loadchainages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLoadChainage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLoadChainage$Response(params: DeleteLoadChainage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteLoadChainage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLoadChainage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLoadChainage(params: DeleteLoadChainage$Params, context?: HttpContext): Observable<void> {
    return this.deleteLoadChainage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getLoadChainages()` */
  static readonly GetLoadChainagesPath = '/v1/loadchainages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoadChainages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoadChainages$Response(params?: GetLoadChainages$Params, context?: HttpContext): Observable<StrictHttpResponse<PageLoadChainageDto>> {
    return getLoadChainages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoadChainages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoadChainages(params?: GetLoadChainages$Params, context?: HttpContext): Observable<PageLoadChainageDto> {
    return this.getLoadChainages$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageLoadChainageDto>): PageLoadChainageDto => r.body)
    );
  }

  /** Path part for operation `createLoadChainage()` */
  static readonly CreateLoadChainagePath = '/v1/loadchainages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLoadChainage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoadChainage$Response(params: CreateLoadChainage$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadChainageDto>> {
    return createLoadChainage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLoadChainage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoadChainage(params: CreateLoadChainage$Params, context?: HttpContext): Observable<LoadChainageDto> {
    return this.createLoadChainage$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoadChainageDto>): LoadChainageDto => r.body)
    );
  }

  /** Path part for operation `getLoadChainagesFiltered()` */
  static readonly GetLoadChainagesFilteredPath = '/v1/loadchainages/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoadChainagesFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getLoadChainagesFiltered$Response(params: GetLoadChainagesFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageLoadChainageDto>> {
    return getLoadChainagesFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoadChainagesFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getLoadChainagesFiltered(params: GetLoadChainagesFiltered$Params, context?: HttpContext): Observable<PageLoadChainageDto> {
    return this.getLoadChainagesFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageLoadChainageDto>): PageLoadChainageDto => r.body)
    );
  }

}
